import axios  from "axios";
import config from "../config/config"

export default class Infrastructure {
    public static getBatchInfrastructure(batchId: string) {
        return axios.get(config.API_URL + '/v1/infrastructure', {
                params: {
                    uuid: batchId,
                    type: 'batch',
                }
            }
        )
    }

    public static getProjectInfrastructure(projectId: string) {
        return axios.get(config.API_URL + '/v1/infrastructure', {
                params: {
                    uuid: projectId,
                    type: 'project',
                }
            }
        )
    }

    public static getNeighbourGrowth(projectId: string) {
        return axios.get(config.API_URL + '/v1/infrastructure/neighbour', {
                params: {
                    uuid: projectId,
                }
            }
        )
    }

    public static getStatistic() {
        return axios.get(config.API_URL + '/v1/infrastructure/statistic')
    }

}